import { extend } from "@react-three/fiber";
import { SparkRenderer as SparkSparkRenderer } from "@sparkjsdev/spark";

export const SparkRenderer = extend(SparkSparkRenderer);
